import React, {useEffect, useState, useContext} from 'react'
import { Result, Skeleton } from 'antd'
import { useHistory } from 'react-router-dom';
import { appContext } from "../../AppContext";
//Hooks
import { useFetch } from './../../Utils/Hooks/useFetch'
import { useTranslation } from 'react-i18next'

export default function EmailValidate()
{
    const [appState] = useContext(appContext);
    const { t } = useTranslation(['login'])
    const history = useHistory();
    const [doFetch] = useFetch();
    const [isLoading, setIsLoading] = useState(true);
    const [isResultSuccess, setIsResultSucces] = useState(false);
    let token = new URLSearchParams(window.location.search).get("token")
    
    useEffect(() => {
        const currentReturnUrl = new URLSearchParams(window.location.search).get("token")

         if(currentReturnUrl !== null)
         {
            history.replace("/validate-email")
         }
    }, // eslint-disable-next-line 
    [])

    useEffect(() => {
        var uri_enc = encodeURIComponent(token);
        doFetch("/Email/validate?token=" + uri_enc)
            .then((response) => onValidatedLoaded(response.isSuccess))

        function onValidatedLoaded(isSuccess) {
            if(isSuccess)
            {
                setIsResultSucces(true)
            }
            setIsLoading(false);
        }
    }, // eslint-disable-next-line 
    [])



    if(isLoading)
    {
        return (
            <Skeleton title={false} paragraph={{rows:1}}/>
        )
    }

    if(isResultSuccess)
    {
        return (
            <Result
                status="success"
                title={t("validateEmail.successTitle")}
                subTitle={t("validateEmail.successSubtitle")}
                extra={<a href={appState.myPrequestUrl}> Log in myPrequest </a>}
            />
        )
    }

    return (
        <Result
            status={500}
            title={t("error.defaultErrorId")}
            subTitle={t("error.defaultErrorDescription")}
        />
    )
}